import React from 'react';

function Header({ filter, setFilter }) {

  return (
    <header className="bg-white shadow-sm">
      <nav className="container mx-auto px-4 py-4">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between">
          <a href="/" className="flex items-center gap-2.5 mb-4 md:mb-0 hover:opacity-80 transition-opacity">
            <img 
              src="/logo.png"
              alt="DefiSea Logo" 
              className="w-9 h-9 md:w-12 md:h-12"
              onError={(e) => {
                // Fallback to SVG if PNG doesn't exist
                e.target.onerror = null;
                e.target.src = "/logo.svg";
              }}
            />
            <h1 className="text-lg md:text-2xl font-bold text-gray-900">DefiSea</h1>
          </a>
          
          <div className="flex items-center gap-4 mb-4 md:mb-0">
            <a
              href="/"
              className="text-gray-700 hover:text-gray-900 px-3 py-2 rounded-md text-sm font-medium transition-colors"
            >
              Home
            </a>
            <a
              href="/DefiSeaLitePaper.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-700 hover:text-gray-900 px-3 py-2 rounded-md text-sm font-medium transition-colors"
            >
              LitePaper
            </a>
            <div className="flex-1 md:max-w-md">
              <label htmlFor="search" className="sr-only">
                Search DeFi protocols
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg
                    className="h-5 w-5 text-gray-400"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      fillRule="evenodd"
                      d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
                <input
                  type="search"
                  id="search"
                  name="search"
                  className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  placeholder="Search protocols..."
                  value={filter}
                  onChange={(e) => setFilter(e.target.value)}
                  aria-label="Search DeFi protocols"
                />
              </div>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Header;